import { GET_BOAT_TYPES_SUCCESS } from "../actionTypes";

const initialState = [];

export default function(state = initialState, action) {
  switch (action.type) {
    case GET_BOAT_TYPES_SUCCESS: {
      const boatTypes = action.payload;

      if (!boatTypes){
        return [...state];
      }

      return [
        ...state,
        ...boatTypes
      ]
    }
    default:
      return state;
  }
}
